import { useBoolean } from '@aibees/shared/hooks';
import { createContext, useContext } from 'react';
import {
  GlobalContextData as ContextData,
  GlobalContextProps as ContextProps,
} from './types';

const context = createContext<ContextData>({} as ContextData);

export const { Provider } = context;

export const useGlobalContext = () => useContext(context);

export const GlobalContextProvider = ({ children, value }: ContextProps) => {
  const isActionInProgress = useBoolean(false);
  return (
    <Provider value={value || { isActionInProgress }}> {children}</Provider>
  );
};
